import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import PortfolioPage from '@features/portfolio/components/PortfolioPage'
import { portfolioKeys } from '@features/portfolio/hooks/queries'
import { ALL_PORTFOLIO_TABS } from '@features/portfolio/utils/portfolio-tabs'
import {
  getBooks,
  getCurrentValuation,
  getPerformanceResult,
  getValueChart,
} from '@features/portfolio/services/portfolio-service'

const DEFAULT_BOOK_ID = 'global'
const DEFAULT_PERIOD = 'max'
const portfolioTabSchema = z.enum(ALL_PORTFOLIO_TABS)
const portfolioSearchSchema = z.object({
  tab: portfolioTabSchema.optional(),
  bookId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/portfolio')({
  validateSearch: (search) => {
    const parsed = portfolioSearchSchema.safeParse(search)
    if (!parsed.success) {
      return {}
    }

    return parsed.data
  },
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.prefetchQuery({
        queryKey: portfolioKeys.books(),
        queryFn: getBooks,
      }),
      context.queryClient.prefetchQuery({
        queryKey: portfolioKeys.valueChart(DEFAULT_BOOK_ID, DEFAULT_PERIOD),
        queryFn: async () => {
          const data = await getValueChart(DEFAULT_BOOK_ID, DEFAULT_PERIOD)
          if (data && data.value_points) {
            return {
              ...data,
              value_points: data.value_points.filter((point) => point.price > 0),
            }
          }
          return data
        },
      }),
      context.queryClient.prefetchQuery({
        queryKey: portfolioKeys.currentValuation(DEFAULT_BOOK_ID),
        queryFn: () => getCurrentValuation(DEFAULT_BOOK_ID),
      }),
      context.queryClient.prefetchQuery({
        queryKey: portfolioKeys.performance(DEFAULT_BOOK_ID, DEFAULT_PERIOD),
        queryFn: () => getPerformanceResult(DEFAULT_BOOK_ID, DEFAULT_PERIOD),
      }),
    ])
  },
  component: PortfolioPage,
})
